import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import cogoToast from 'cogo-toast';
import { adminAPIURL, customHeaders } from '../../../../../../Containers/Config/index.js';
import { VALIDATE_OTP, VALIDATE_OTP_ERROR, VALIDATE_OTP_SUCCESS } from '../../../../actionType.js';
import apiCall from '../../../../apiCall.js';

function* validateOTP({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v1/validate-otp`,
      method: 'POST',
      headers: {
        ...filteredHeaders,
      },
      data: {
        ...payload?.body,
      },
    });

    if (response.status === 200) {
      cogoToast.success(response?.data?.message);
      yield put({
        type: VALIDATE_OTP_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(response?.response?.data?.message);
      yield put({
        type: VALIDATE_OTP_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: VALIDATE_OTP_ERROR, payload: error });
  }
}

export function* watchValidateOTP() {
  yield takeEvery(VALIDATE_OTP, validateOTP);
}

function* validateOTPSaga() {
  yield all([fork(watchValidateOTP)]);
}

export default validateOTPSaga;
